import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import styles from "./SelectOption.module.scss";

export interface ISelectOption {
  label: string;
  value: any;
  data?: any;
}

interface IProps {
  className?: string;
  label?: string;
  required?: boolean;
  options: ISelectOption[];
  onChange?: (val: any) => void;
  placeholder?: string;
  value?: ISelectOption | [];
  errors?: { isShow: boolean; message: string }[];
  disabled?: boolean;
}

const SelectOption = (props: IProps) => {
  const { placeholder = "Select..." } = props;
  const customStyles = {
    control: (provided: any) => {
      return {
        ...provided,
        borderRadius: 40,
        minHeight: 40,
        borderWidth: 0,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 5,
        border: "1px solid #E5F0FE",
      };
    },
    dropdownIndicator: (provided: any) => {
      return {
        ...provided,
        color: "#004888",
      };
    },
    indicatorSeparator: (provided: any) => {
      return { ...provided, width: 0 };
    },
    placeholder: (provided: any) => {
      return { ...provided, color: "#CAD1DC" };
    },
  };

  return (
    <Row className={[props.className].join(" ")}>
      <Col>
        {props.label && (
          <label className={[styles.label].join(" ")}>
            {props.label}{" "}
            {props.required && <span className="text-danger">*</span>}
          </label>
        )}

        <Select
          options={props.options}
          styles={customStyles}
          placeholder={placeholder}
          value={props.value}
          isDisabled={props.disabled}
          onChange={(val) => {
            props.onChange && props.onChange(val);
          }}
        />
        {props.errors?.map(
          (error, index) =>
            error.isShow && (
              <p key={index} className={styles.error}>
                {error.message}
              </p>
            )
        )}
      </Col>
    </Row>
  );
};

export default SelectOption;
